import styled from "styled-components";

export const Wrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: auto;

  .loader {
    height: 4px;
    background-color: #eee;
    width: 100px;
    margin-top: 32px;
    border-radius: 100px;
    position: relative;
    overflow-x: hidden;
  }

  .loader::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background-color: #666;
    animation: loading 2s infinite;
  }

  @keyframes loading {
    0% {
      left: -30%;
    } 50% {
      left: 80%;
    } 100% {
      left: -30%;
    }
  }

  .loading-card {
    width: 48px;
    height: auto;
    animation: shine 3s infinite cubic-bezier(0.96, 0.75, 0.21, 0.9);
  }

  @keyframes shine {
    0% {
      filter: brightness(1);
    }
    50% {
      filter: brightness(1.1);
    }
    100% {
      filter: brightness(1);
    }
  }

  p {
    font-size: 16px;
    margin-top: 24px !important;
    width: 350px;
  }
`;

